import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/box/box.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/Hero_Image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/Intro_Img.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review1_Bg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review2_Bg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review3_Bg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review4_Bg.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/customer-testimonials/review4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/certificates/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contactForm/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/features/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ourCustomers/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/technologyPartners/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/customerTestimonial/components/body.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/customerTestimonial/components/intro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/customerTestimonial/components/stories.tsx");
